const toggleEventsAccordion = {
	el: {
		accordionElement: document.querySelectorAll('.js-accordion-toggle')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 75em)')
	},

	fxToggleClasses(el) {
		// add/remove open class on current target
		if (el.currentTarget.parentElement.classList.contains('open')) {
			if (el.currentTarget.classList.contains('content-columns__header')) {
				!this.vars.extraLargeAndUp.matches && (el.currentTarget.parentElement.classList.remove('open'), this.fxCloseAccordion(el.currentTarget))
			}
			else {
				el.currentTarget.parentElement.classList.remove('open')
				this.fxCloseAccordion(el.currentTarget)
			}

		}
		else {
			if (el.currentTarget.classList.contains('content-columns__header')) {
				!this.vars.extraLargeAndUp.matches && (el.currentTarget.parentElement.classList.add('open'), this.fxOpenAccordion(el.currentTarget), this.fxCloseSiblings(el.currentTarget.parentElement, el.currentTarget.closest('.js-accordion')))
			}
			else {
				el.currentTarget.parentElement.classList.add('open')
				this.fxOpenAccordion(el.currentTarget)
				this.fxCloseSiblings(el.currentTarget.parentElement, el.currentTarget.closest('.js-accordion'))
			}
		}
	},

	fxCloseSiblings(element, parent) {
		const children = [...parent.children]
		// loop through siblings and remove open class
		children.filter(child => child !== element && child.classList.contains('open') && (child.classList.remove('open'), this.fxCloseAccordion(child.querySelector('.js-accordion-toggle'))))
	},

	fxOpenAccordion(el) {
		const content = el.nextElementSibling
		content.style.maxHeight = content.scrollHeight + 'px'
	},

	fxCloseAccordion(el) {
		const content = el.nextElementSibling
		content.style.maxHeight = null
	},

	events(el) {
		el.forEach(el => el.addEventListener('click', e => this.fxToggleClasses(e)))
	},

	init() {
		this.events(this.el.accordionElement)
	}
}

toggleEventsAccordion.init()